/* eslint-disable import/order */
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { nextBestTaskFeatureResource } from '@jira/router-resources__next-best-task/src/nextBestTaskFeatureResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import type { RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getLabsResources = (): RouteResource<any>[] => [
	resourceWithCondition(
		() =>
			fg('aem_rr_personal_settings')
				? isFeatureEnabled('jira', 'jira-next-best-task')
				: !isFedRamp(),
		nextBestTaskFeatureResource,
	),
];
